import classnames from 'classnames';
import React from 'react';

/**
 * The stepper Counter displays the sequential number of a step and sets
 * styling for the state of completion.
 */
const Counter = (props) => {
  const { active, index, pending } = props;
  let modifier = null;

  if (active) {
    modifier = 'stepper__step-counter--pressed';
  } else if (pending) {
    modifier = 'stepper__step-counter--pending';
  }

  const className = classnames(
    'stepper__step-counter',
    modifier,
  );

  return (
    <div data-test="step.counter" className={className}>{index + 1}</div>
  );
};

export default Counter;
